const ChineseAcademy = {
  beranda: '主页',
  tentangAkademi: '关于学院',
  visimisi: '愿景和使命',
  program: '程序',
  paket: '套餐',
  pusatPelatihan: '培训中心',
  lainnya: '其他',
};

export default ChineseAcademy